import React, { useEffect, useState, useMemo } from 'react';
import { withTranslation } from 'react-multi-lang';
import { Card, CardBody, CardHeader, Row, Col, Table, Input, Button,
        Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Form, CardFooter,
    InputGroup, InputGroupAddon } from 'reactstrap';
import Select from 'react-select';
import VolumesService from '../Services/VolumesService';
import SalesService from '../Services/SalesService';
import AuthService from '../Services/AuthService';
import makeAnimated from 'react-select/animated';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCamera, faPlus, faScaleUnbalanced, faSync, faTrashRestore, faVideoCamera } from '@fortawesome/free-solid-svg-icons';
import { useToasts } from 'react-toast-notifications';
import { VehiclesService } from '../Services/VehiclesService';
import LocalService from '../Services/LocalService';
import { debounce, set } from 'lodash';


const Sales = ({t}) => {
    const [sales, setSales] = useState([]);
    const [products, setProducts] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [customerCode, setCustomerCode] = useState('');
    const [vehicles, setVehicles] = useState([]);
    const [activeVehicle, setActiveVehicle] = useState({});
    const [newOfferCustomer, setNewOfferCustomer] = useState('');
    const [projects, setProjects] = useState([]);
    const [newSale, setNewSale] = useState({
        hasTransportCost: false
    });
    const [initVehicleWeight, setInitVehicleWeight] = useState(0);
    const [updateVeh, setUpdateVeh] = useState(false);

    const [customerCost, setCustomerCost] = useState(0);
    const [newOfferItems, setNewOfferItems] = useState([]);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [totalEntries, setTotalEntries] = useState(0);
    const [saleSearch, setSaleSearch] = useState('');
    const [customersSearch, setCustomersSearch] = useState('');
    const [currentOffer, setCurrentOffer] = useState(0);
    const [creatingSale, setCreatingSale] = useState(false);
    const [user, setUser] = useState({});
    const [canEditTare, setCanEditTare] = useState(false);
    const [latestPlate, setLatestPlate] = useState('');

    const { addToast } = useToasts();

    const salesService = useMemo(() => new SalesService(), []);
    const vehiclesService = useMemo(() => new VehiclesService(), []);
    const localService = useMemo(() => new LocalService(), []);
    const authService = useMemo(() => new AuthService(), []);
    const animatedComponents = makeAnimated();

    const totalPages = Math.max(1, Math.ceil(totalEntries / perPage));
    const currentPage = Math.min(Math.max(1, page), totalPages);
    const startIndex = totalEntries === 0 ? 0 : (currentPage - 1) * perPage;
    const endIndex = startIndex + perPage;

    const getPageNumbers = () => {
        const pages = [];
        const maxVisible = 5;
        let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
        let end = Math.min(totalPages, start + maxVisible - 1);
        if (end - start + 1 < maxVisible) {
            start = Math.max(1, end - maxVisible + 1);
        }
        for (let i = start; i <= end; i++) {
            pages.push(i);
        }
        return pages;
    };

    const fetchSales = (targetPage = page, targetPerPage = perPage, targetSearch = saleSearch) => {
        salesService.getSales(targetSearch, targetPage, targetPerPage).then(r => {
            if (r) {
                setSales(r[0] || []);
                setTotalEntries(r[1] || 0);
            }
        }).catch(e => {
            console.error(e);
        });
    };

    const toggleCreatingSale = () => {
        if(!creatingSale){
            newSale.TransCostVal = 0;
        }
        else{
            setNewSale({});
            setCanEditTare(false);
            setLatestPlate('');
            setActiveVehicle({});
        }
        setCreatingSale(!creatingSale);
        
    };

    useEffect(() => {
        fetchSales(page, perPage, saleSearch);
    }, [page, perPage, saleSearch]);

    useEffect(() => {
        const maxPage = Math.max(1, Math.ceil(totalEntries / perPage));
        if (totalEntries > 0 && page > maxPage) {
            setPage(maxPage);
        }
    }, [totalEntries, perPage, page]);

    useEffect(() => {
        let u = authService.getUser();
        setUser(u);
        salesService.getProducts().then(r => {
            console.log(r);
            setProducts(r)
        });

        getVehicles();
        
    }, []);

    const getVehicles = () => {
        vehiclesService.getVehicles('', 1, 20000).then(r => setVehicles(r[0])).catch(e => addToast(t('stock.errorGettingVehicles'), {appearance: 'error', autoDismiss: true, autoDismissTimeout: 5000}));
    };

    const createSale = () => {
        salesService.createSale(newSale).then(r => {
            setPage(1);
            fetchSales(1, perPage, saleSearch);
            if(updateVeh){
                vehiclesService.saveVehicle(activeVehicle).then(r => setUpdateVeh(false));
            }
            toggleCreatingSale();
            setNewSale({});
            setNewOfferCustomer('');
        });
    };

    const syncToErp = (sale) => {
        salesService.syncSaleToErp(sale).then(r => {  
            fetchSales(page, perPage, saleSearch);
        });
    };
    const getWeight = () => {
        let weight = 0;
        if(activeVehicle && activeVehicle.weight) {
            localService.getWeightFromScale().then(r => {
                setNewSale({...newSale, weight: r - activeVehicle.weight, qty: r - activeVehicle.weight, tareWeight: activeVehicle.weight, totalWeight: r});
            }).catch(e => addToast('Σφάλμα σύνδεσης με ζυγό', {appearance: 'error', autoDismiss: true, autoDismissTimeout: 5000}));
        }
        else{
            addToast(t('Πρέπει να επιλέξετε όχημα'), {appearance: 'error', autoDismiss: true, autoDismissTimeout: 5000});
        }
    }

    const getLatestPlate = async () => {
        let plate = await localService.getLatestPlate();
        setLatestPlate(plate);
        let veh = vehicles.find(v => v.plates.replace(/ /g, '') === plate.replace(/ /g, '') || v.plates.replace(/ /g, '').substring(3, 7) === plate.replace(/ /g, '').substring(3, 7));
        setActiveVehicle(vehicles.find(v => v.plates.replace(/ /g, '') === plate.replace(/ /g, '') || v.plates.replace(/ /g, '').substring(3, 7) === plate.replace(/ /g, '').substring(3, 7)));
        if(veh && vehicles.find(v => v.plates.replace(/ /g, '') === plate.replace(/ /g, '') || v.plates.replace(/ /g, '').substring(3, 7) === plate.replace(/ /g, '').substring(3, 7)).weight <= 0){
            setCanEditTare(true);
        }
    };

    const updateCustomerCost = async (code) => {
        let cpc = await salesService.getCostPerCustomer(code);
        if(cpc){
            setCustomerCost(cpc.pricePerTone);
        }
    };

    const searchCustomers = debounce((v) => {
        if(v)
            salesService.getCustomers(v).then(r => setCustomers(r));
        else setCustomers([]);
    }, 300);

    useEffect(() => {
        if(customerCode)
            salesService.getProjects(customerCode).then(r => setProjects(r));
        else setProjects([]);
    }, [customerCode]);

    useEffect(() => {

    }, [newSale.ProjectCode])

    return <>
        <Card>
            <CardHeader className="bg-primary text-white">
                <h3>Αποστολές</h3>
            </CardHeader>
            <CardBody>
                <Row className="mb-3 align-items-center">
                    <Col>
                        <Input 
                            type="search" 
                            id="saleSearchInput"
                            placeholder={t('search')} 
                            value={saleSearch}
                            onChange={(e) => {
                                setSaleSearch(e.target.value);
                                setPage(1);
                            }} 
                        />
                    </Col>
                    <Col xs="auto">
                        <Button color="primary" onClick={toggleCreatingSale}><FontAwesomeIcon icon={faPlus} /> </Button>
                    </Col>
                </Row>
                <hr />
                <Table responsive striped id="salesTable">
                    <thead>
                        <tr>
                            <th>Ημερομηνία/Ώρα</th>
                            <th>Κωδικός Πελάτη</th>
                            <th>Όνομα Πελάτη</th>
                            <th>Κωδικός Είδους</th>
                            <th>Ποσότητα</th>
                            <th>Πινακίδα</th>
                            <th>Ενέργειες</th>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        sales.length === 0 && <tr><td colSpan={7} className="text-center">Δεν υπάρχουν Εγγραφές</td></tr>
                    }
                    {
                        sales.map(s => {
                            return  <tr key={s.id}>
                                        <td>{s && s.datetime && s.datetime.split('T')[0].split('-').reverse().join('-')} {s.datetime.split('T')[1].substr(0, 5)}</td>
                                        <td>{s.customerCode}</td>
                                        <td>{s.customerName}</td>
                                        <td>{s.prod_code}</td>
                                        <td>{(s.qty / 1000).toFixed(2)}</td>
                                        <td>{s.vehiclePlate}</td>
                                        <td>
                                            {s.sent === false && 
                                            <Button size='sm' color="primary" onClick={() => {
                                                syncToErp(s);
                                            }}>
                                                <FontAwesomeIcon icon={faSync} />
                                            </Button>
                                            }
                                        </td>
                                    </tr>
                        })
                    }
                    </tbody>
                </Table>
            </CardBody>
            <CardFooter className="d-flex flex-wrap justify-content-between align-items-center py-2 bg-white border-top">
                <div className="d-flex flex-wrap align-items-center my-1">
                    <span className="text-muted small me-3 mr-3" id="showingEntriesText">
                        {t('users.showing') || 'Showing'} {totalEntries === 0 ? 0 : startIndex + 1} - {Math.min(endIndex, totalEntries)} {t('users.of') || 'of'} {totalEntries}
                    </span>
                    <div className="d-flex align-items-center">
                        <Label for="perPageSelect" className="mb-0 me-2 mr-2 text-nowrap small text-muted">
                            {t('users.perPage') || 'Per page'}:
                        </Label>
                        <Input
                            type="select"
                            id="perPageSelect"
                            data-testid="perPageSelect"
                            bsSize="sm"
                            style={{ width: '80px', display: 'inline-block' }}
                            value={perPage.toString()}
                            onChange={(e) => {
                                setPerPage(Number(e.target.value));
                                setPage(1);
                            }}
                        >
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                        </Input>
                    </div>
                </div>

                <div className="d-flex align-items-center my-1" id="paginationControls" data-testid="paginationControls">
                    <Button 
                        color="secondary" 
                        outline 
                        size="sm" 
                        onClick={() => setPage(1)} 
                        disabled={currentPage <= 1} 
                        className="me-1 mr-1" 
                        title={t('users.first') || 'First'}
                        id="firstPageBtn"
                    >
                        «
                    </Button>
                    <Button 
                        color="secondary" 
                        outline 
                        size="sm" 
                        onClick={() => setPage(p => Math.max(1, p - 1))} 
                        disabled={currentPage <= 1} 
                        className="me-1 mr-1" 
                        title={t('users.previous') || 'Previous'}
                        id="prevPageBtn"
                    >
                        ‹
                    </Button>
                    {getPageNumbers().map(p => (
                        <Button
                            key={p}
                            color={p === currentPage ? "primary" : "secondary"}
                            outline={p !== currentPage}
                            size="sm"
                            onClick={() => setPage(p)}
                            className="me-1 mr-1"
                        >
                            {p}
                        </Button>
                    ))}
                    <Button 
                        color="secondary" 
                        outline 
                        size="sm" 
                        onClick={() => setPage(p => Math.min(totalPages, p + 1))} 
                        disabled={currentPage >= totalPages} 
                        className="me-1 mr-1" 
                        title={t('users.next') || 'Next'}
                        id="nextPageBtn"
                    >
                        ›
                    </Button>
                    <Button 
                        color="secondary" 
                        outline 
                        size="sm" 
                        onClick={() => setPage(totalPages)} 
                        disabled={currentPage >= totalPages} 
                        title={t('users.last') || 'Last'}
                        id="lastPageBtn"
                    >
                        »
                    </Button>
                </div>
            </CardFooter>
        </Card>
        <Modal isOpen={creatingSale} toggle={toggleCreatingSale} size="xl" centered>
            <ModalHeader>
                <h3>Δημιουργία Δελτίου Αποστολής</h3>
            </ModalHeader>
            <ModalBody>
                <Row>
                    <Col md="12">
                        <FormGroup>
                            <Label>Πελάτης</Label>
                            <Select multiple={false}
                                closeMenuOnSelect={true}
                                options={[{value: '', label: ''}, ...customers
                                .map(c => {
                                    return {value: c.Code, label: c.Code + ' - ' + c.TaxRegistrationNumber + ' - ' + c.Name}
                                })]}
                                onChange={(v) => {
                                    updateCustomerCost(v.value);
                                    setCustomerCode(v.value);
                                    setNewSale({
                                        ...newSale, 
                                        customerCode: v.value,
                                        customerName: v.label.split(' - ')[2],
                                        customerVat: v.label.split(' - ')[1],
                                        customerId: customers.find(c => c.Code === v.value).TradeAccGID,
                                    })
                                } }
                                onInputChange={searchCustomers}
                            />
                            
                        </FormGroup>
                        <FormGroup>
                            <Label>Project</Label>
                            <Select multiple={false}
                                closeMenuOnSelect={true}
                                options={[{value: '', label: ''}, ...projects
                                .map(c => {
                                    return {value: c.ProjectCode, label: c.ProjectCode + ' - ' + c.ProjectName}
                                })]}
                                onChange={(v) => {
                                    setNewSale({
                                        ...newSale,
                                        ProjectCode: v.value
                                    });
                                    setCustomerCost(projects.find(p => p.ProjectCode === v.value).ProjectTransCost);
                                } }
                            />
                            
                        </FormGroup>
                        <hr />
                        <Row>
                            <Col md="2">
                                <FormGroup>
                                    <Label>Ενημέρωση από Κάμερα</Label>
                                    <Button color="primary" onClick={() => {
                                        getLatestPlate();
                                    }}> <FontAwesomeIcon icon={faVideoCamera} /> </Button>{' '}
                                    <Button color="warning" onClick={() => {
                                        setLatestPlate('');
                                    }}> <FontAwesomeIcon icon={faTrashRestore} /> </Button>
                                    
                                </FormGroup>
                            </Col>
                            <Col md="8">
                                <FormGroup>
                                    <Label>Όχημα</Label>
                                    <Select multiple={false}
                                            closeMenuOnSelect={true}
                                            onMenuScrollToBottom={() => {

                                            }}
                                            options={[{value: null, label: ''}, ...vehicles
                                            .filter(v => latestPlate ? v.plates.replace(/ /g, '') === latestPlate.replace(/ /g, '') || v.plates.replace(/ /g, '').substring(3, 7) === latestPlate.replace(/ /g, '').substring(3, 7) : true)
                                            .map(v => {
                                                return {value: v, label: v.plates + ( v.secondPlates ? ' - ' + v.secondPlates : '')}
                                            })]}
                                            value={activeVehicle && activeVehicle.plates ? {value: activeVehicle, label: activeVehicle.plates + ( activeVehicle.secondPlates ? ' - ' + activeVehicle.secondPlates : '')} : {value: {}, label: 'Επιλέξτε Όχημα'}}
                                            onChange={(v) => {
                                                if(v.value){
                                                    setNewSale({
                                                        ...newSale, 
                                                        vehiclePlate: v.value.plates,
                                                    });
                                                    setActiveVehicle(v.value);
                                                    setInitVehicleWeight(v.value.weight);
                                                    if(v.value.weight <= 0){
                                                        setCanEditTare(true);
                                                    }
                                                }
                                            }
                                            
                                        }
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label>Απόβαρο οχήματος</Label>
                                    <Input type="number" value={activeVehicle ? activeVehicle.weight : 0} 
                                    min={initVehicleWeight && initVehicleWeight > 0 ? initVehicleWeight * 0.95 : null}
                                    max={initVehicleWeight && initVehicleWeight > 0 ? initVehicleWeight * 1.05 : null} 
                                    onChange={(e) => {
                                        setActiveVehicle({
                                            ...activeVehicle, weight: e.target.valueAsNumber
                                        });
                                        setUpdateVeh(true)
                                    }
                                } />
                                </FormGroup>
                            </Col>
                        </Row>
                        
                        <hr />
                        {
                            newSale.customerCode && newSale.ProjectCode && newSale.qty > 0 && <>
                                <Row>
                                    <Col md="4">
                                        <Card style={{padding: '20px', border: newSale.TransCostVal > 0 ? '#aaaaff 2px solid' : ''}} onClick={() => setNewSale({
                                            ...newSale,
                                            TransCostVal: newSale.qty > 0 ? (newSale.qty/1000) * customerCost : 0
                                        })}>
                                            <CardHeader>Χρέωση Μεταφορικών</CardHeader>
                                            <p>{ (newSale.qty > 0 ? (newSale.qty/1000) * customerCost : 0).toFixed(2)} &euro;</p>
                                        </Card>
                                    </Col>
                                    <Col md="4">
                                        <Card style={{padding: '20px', border: newSale.TransCostVal > 0 ? '' : '#aaaaff 2px solid'}} onClick={() => setNewSale({
                                            ...newSale,
                                            TransCostVal: 0
                                        })}>
                                            <CardHeader>Χωρίς Χρέωση Μεταφορικών</CardHeader>
                                            <p>0.00 &euro;</p>
                                        </Card>
                                    </Col>
                                </Row>
                            </>
                        }
                        
                    </Col>
                    <Col md="12">
                        
                        <Table responsive>
                            <thead>
                                <tr>
                                    <th width="50%">Είδος</th>
                                    <th>Μεικτό Βάρος</th>
                                    <th>Απόβαρρο</th>
                                    <th>Βάρος</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr >
                                    <td>
                                        <Select
                                            closeMenuOnSelect={true}
                                            components={animatedComponents}
                                            defaultValue={''}
                                            options={(products.length > 0 ? products : [])
                                                .map(p => {
                                                return {value: p.ItemCode, label: p.ItemCode + '-' + p.ItemDescr}
                                            })}
                                            onChange={(v) => {
                                                setNewSale({
                                                    ...newSale, prod_code: v.value
                                                })
                                            }}
                                        />
                                    </td>
                                    <td>{ newSale.totalWeight }</td>
                                    <td>{ newSale.tareWeight }</td>
                                    <td>
                                        <InputGroup>
                                            <Input type="number" value={newSale.weight} min={0} readOnly={!(user.role === 'admin' || user.role === 'manager')} step="any" onChange={(e) => {
                                                setNewSale({
                                                    ...newSale, qty: e.target.valueAsNumber
                                                })
                                            }} />
                                            <Button color="warning" type="button" size="sm" onClick={() => {
                                                getWeight()
                                            }}> <FontAwesomeIcon icon={faScaleUnbalanced} /> </Button>
                                        </InputGroup>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button className="float-end" color="success" size="sm" onClick={createSale}>{t('volumes.create')}</Button>
                <Button className="float-end" color="warning" size="sm" onClick={toggleCreatingSale}>{t('volumes.close')}</Button>
            </ModalFooter>
        </Modal>
    </>
};

export default withTranslation(Sales);